/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { contentText, titleText } from "@monsma/App/WidgetExtensions/OrderDetails/OrderDateExtension";
import { rfqQuoteDetailsInformationStyles } from "@monsma/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation";
import { css } from "styled-components";

rfqQuoteDetailsInformationStyles.detailsGridContainer = {
    gap: 15,
};

rfqQuoteDetailsInformationStyles.jobNameGridItem = {
    width: [12, 6, 4, 4, 4],
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

rfqQuoteDetailsInformationStyles.salesRepGridItem = rfqQuoteDetailsInformationStyles.jobNameGridItem;

rfqQuoteDetailsInformationStyles.userGridItem = rfqQuoteDetailsInformationStyles.jobNameGridItem;

rfqQuoteDetailsInformationStyles.statusGridItem = rfqQuoteDetailsInformationStyles.jobNameGridItem;

rfqQuoteDetailsInformationStyles.customerGridItem = rfqQuoteDetailsInformationStyles.jobNameGridItem;

rfqQuoteDetailsInformationStyles.shipToGridItem = rfqQuoteDetailsInformationStyles.jobNameGridItem;

rfqQuoteDetailsInformationStyles.expirationDateGridItem = {
    width: 12,
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

rfqQuoteDetailsInformationStyles.notesGridItem = { width: 12 };

rfqQuoteDetailsInformationStyles.dateGridItem = rfqQuoteDetailsInformationStyles.jobNameGridItem;

rfqQuoteDetailsInformationStyles.expirationDateLabelText = titleText;
rfqQuoteDetailsInformationStyles.dateLabelText = titleText;

rfqQuoteDetailsInformationStyles.xRfqQuoteDetailsInformationStyles = {
    dateText: contentText,
    editableExpirationDateGridItem: {
        css: css`
            &&& {
                display: none !important;
            }
        `,
    },
};

rfqQuoteDetailsInformationStyles.jobNameHeadingAndText = {
    heading: titleText,
    text: contentText,
};

rfqQuoteDetailsInformationStyles.salesRepHeadingAndText = {
    heading: titleText,
    text: contentText,
};

rfqQuoteDetailsInformationStyles.userHeadingAndText = {
    heading: titleText,
    text: contentText,
};

rfqQuoteDetailsInformationStyles.statusHeadingAndText = {
    heading: titleText,
    text: contentText,
};

rfqQuoteDetailsInformationStyles.customerHeadingAndText = {
    heading: titleText,
    text: contentText,
};

rfqQuoteDetailsInformationStyles.shipToHeadingAndText = {
    heading: titleText,
    text: contentText,
};

rfqQuoteDetailsInformationStyles.notesHeadingAndText = {
    heading: titleText,
    text: contentText,
};

rfqQuoteDetailsInformationStyles.expirationDateDatePicker = {
    cssOverrides: {
        ...rfqQuoteDetailsInformationStyles.expirationDateDatePicker?.cssOverrides,
        formField: css`
            > ${TypographyStyle} {
                font-size: 16px;
            }
        `,
    },
};
